/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TourEditTodoRefetchQueryVariables = {
    id: string;
};
export type TourEditTodoRefetchQueryResponse = {
    readonly node: {
        readonly " $fragmentRefs": FragmentRefs<"TourEdit_tour">;
    } | null;
};
export type TourEditTodoRefetchQuery = {
    readonly response: TourEditTodoRefetchQueryResponse;
    readonly variables: TourEditTodoRefetchQueryVariables;
};



/*
query TourEditTodoRefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...TourEdit_tour
    id
  }
}

fragment TourAddMarkers_tour on Tour {
  id
  title
}

fragment TourEditDrawerMarkers_tour on Tour {
  markers {
    id
    name
    isFastTravel
    frameIndex
  }
  id
}

fragment TourEdit_tour on Tour {
  ...TourPlayerCanvas_tour
  ...TourEditDrawerMarkers_tour
  ...TourAddMarkers_tour
  title
  thumbnailURL
  markers {
    id
    name
    description
    scrollPosition
    frameIndex
  }
  id
}

fragment TourPlayerCanvas_tour on Tour {
  id
  title
  description
  videoURL
  thumbnailURL
  tourIntroLogoURL
  videoInfo {
    width
    height
    fullSize
    mediumSize
    smallSize
  }
  markers {
    id
    name
    description
    scrollPosition
    frameIndex
  }
  clips {
    id
    index
    frameCount
    duration
    highURI
    lowURI
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourEditTodoRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TourEdit_tour"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourEditTodoRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnailURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tourIntroLogoURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TourVideoInfo",
                "kind": "LinkedField",
                "name": "videoInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediumSize",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "smallSize",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Marker",
                "kind": "LinkedField",
                "name": "markers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scrollPosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frameIndex",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFastTravel",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Clip",
                "kind": "LinkedField",
                "name": "clips",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "index",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frameCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highURI",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lowURI",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Tour",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4420db05d1f62140d7d2b32dd8d29e2a",
    "id": null,
    "metadata": {},
    "name": "TourEditTodoRefetchQuery",
    "operationKind": "query",
    "text": "query TourEditTodoRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...TourEdit_tour\n    id\n  }\n}\n\nfragment TourAddMarkers_tour on Tour {\n  id\n  title\n}\n\nfragment TourEditDrawerMarkers_tour on Tour {\n  markers {\n    id\n    name\n    isFastTravel\n    frameIndex\n  }\n  id\n}\n\nfragment TourEdit_tour on Tour {\n  ...TourPlayerCanvas_tour\n  ...TourEditDrawerMarkers_tour\n  ...TourAddMarkers_tour\n  title\n  thumbnailURL\n  markers {\n    id\n    name\n    description\n    scrollPosition\n    frameIndex\n  }\n  id\n}\n\nfragment TourPlayerCanvas_tour on Tour {\n  id\n  title\n  description\n  videoURL\n  thumbnailURL\n  tourIntroLogoURL\n  videoInfo {\n    width\n    height\n    fullSize\n    mediumSize\n    smallSize\n  }\n  markers {\n    id\n    name\n    description\n    scrollPosition\n    frameIndex\n  }\n  clips {\n    id\n    index\n    frameCount\n    duration\n    highURI\n    lowURI\n  }\n}\n"
  }
};
})();
(node as any).hash = '1899f4aa87f9d04637536712ff47c1ff';
export default node;
